import DownloadIcon from '@mui/icons-material/Download';
import { Box, Tooltip } from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import { amplitude } from 'wisestep-api';
import { Item, WsButton } from 'wisestep-base';

import { useWorkspaceContext } from '../../../../../context';
import { downloadAttachment, singleDataType, singleDataHandleType } from '../helper';

export const Attachments = (
  handleContent: singleDataType,
  singleDataHandle: singleDataHandleType
) => {
  const workspace = useWorkspaceContext();
  return handleContent.content &&
    handleContent.content.attachments &&
    !isEmpty(handleContent.content?.attachments) &&
    singleDataHandle.configuredAccounts
    ? handleContent.content.attachments.map((attachment, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            position: 'relative',
          }}
        >
          <Item>
            <Tooltip title="Download">
              <Box textAlign="center">
                <WsButton
                  startIcon={<DownloadIcon sx={{ color: "text.primary'" }} />}
                  variant="contained"
                  onClick={() => {
                    amplitude('Inbox_Inbox_attachment_download', {
                      clickedOn: 'Inbox Attachment Download',
                      workspaceName: workspace.name,
                      pageName: 'Mail',
                      planType: workspace.planType,
                      interfaceType: 'web',
                      pageUrl: window.location.href,
                    });
                    downloadAttachment(
                      handleContent.content.messageId,
                      attachment.uuid,
                      singleDataHandle
                    );
                  }}
                >
                  {attachment.fileName}
                </WsButton>
              </Box>
            </Tooltip>
          </Item>
        </Box>
      ))
    : [<></>];
};
